import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-085c7964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar--container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  loading: "lazy",
  class: "navbar--logo",
  src: _imports_0,
  alt: "Rockwool logo"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "navbar--menu"
}
const _hoisted_4 = {
  key: 0,
  class: "navbar-menu-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mobile_menu = _resolveComponent("mobile-menu")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "navbar",
    class: _normalizeClass(["navbar", { 'only-one': _ctx.isOnlyOne }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      (_ctx.$route.name !== 'CreateReview')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["nav-item menu-item-1", _ctx.checkRouteHome]),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToHome && _ctx.redirectToHome(...args)))
                    }, " Mapa wykonawców ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["nav-item menu-item-2", _ctx.checkRestRoutes]),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenuVisibility && _ctx.toggleMenuVisibility(...args)))
                    }, " Strefa wykonawców ", 2)
                  ]),
                  (_ctx.menuVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", {
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToSuperWykonawca && _ctx.redirectToSuperWykonawca(...args)))
                        }, "Zostań Superwykonawcą"),
                        _createElementVNode("p", {
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToAplikacja && _ctx.redirectToAplikacja(...args)))
                        }, "Aplikacja"),
                        _createElementVNode("p", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToProgram && _ctx.redirectToProgram(...args)))
                        }, "Program lojalnościowy"),
                        _createElementVNode("p", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToYoutube && _ctx.redirectToYoutube(...args)))
                        }, "You Tube")
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_mobile_menu)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}